export default "__VITE_ASSET__DrR_JjF4__"